import requestv2 from "~/utils/http-v2";

const receiptApi = {
	gets: async (params) => {
		const url = 'v2/receipt';
		return await requestv2.get(url, {params});
	},
	add: async (params) => {
		const url = 'v2/receipt';
		return await requestv2.post(url, params);
	},
	update: async (params) => {
		const url = `v2/receipt/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete: async (id) => {
		const url = `v2/receipt/${id}`;
		return await requestv2.delete(url);
	},

	groupGets: async (params) => {
		const url = 'v2/receipt/group';
		return await requestv2.get(url, {params});
	},
	groupAdd: async (params) => {
		const url = 'v2/receipt/group';
		return await requestv2.post(url, params);
	},
	groupUpdate: async (params) => {
		const url = `v2/receipt/group/${params.id}`;
		return await requestv2.patch(url, params);
	},
	groupDelete: async (id) => {
		const url = `v2/receipt/group/${id}`;
		return await requestv2.delete(url);
	},
};

export default receiptApi;

